var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethodPad = function SvgPaymentMethodPad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 15,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0071 5C17.8598 5 18.5703 5.29901 19.1387 5.89703C19.7131 6.49506 20.0002 7.23222 20.0002 8.10853C20.0002 8.98484 19.7131 9.72201 19.1387 10.32C18.5703 10.9181 17.8598 11.2171 17.0071 11.2171H14.5381V5H17.0071ZM17.0071 10.0447C17.546 10.0447 17.9841 9.86707 18.3216 9.51181C18.6591 9.15063 18.8279 8.68287 18.8279 8.10853C18.8279 7.53419 18.6591 7.06939 18.3216 6.71413C17.9841 6.35295 17.546 6.17236 17.0071 6.17236H15.7637V10.0447H17.0071Z",
    fill: "#2E3330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6025 11.2171L12.2295 10.098H9.75155L9.37852 11.2171H8.05518L10.2311 5H11.7499L13.9347 11.2171H12.6025ZM10.1423 8.95228H11.8476L10.995 6.41216L10.1423 8.95228Z",
    fill: "#2E3330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31808 5C6.9161 5 7.41939 5.20131 7.82794 5.60394C8.23649 6.00657 8.44076 6.50098 8.44076 7.08716C8.44076 7.67334 8.23649 8.16774 7.82794 8.57037C7.41939 8.973 6.9161 9.17432 6.31808 9.17432H5.22565V11.2171H4V5H6.31808ZM6.31808 8.0286C6.5786 8.0286 6.79472 7.93978 6.96643 7.76215C7.13814 7.5786 7.22399 7.3536 7.22399 7.08716C7.22399 6.81479 7.13814 6.58979 6.96643 6.41216C6.79472 6.23453 6.5786 6.14572 6.31808 6.14572H5.22565V8.0286H6.31808Z",
    fill: "#2E3330"
  })));
};
export default SvgPaymentMethodPad;